import { Component, h, Prop } from '@stencil/core';
import { TIcon } from '../../../components';

@Component({
  tag: 'dc-ui-meta-nav-link',
  styleUrl: '../dc-ui-meta-nav-button/dc-ui-meta-nav-button.scss',
  shadow: true,
})
export class DcUiMetaNavLink {
  @Prop() label: string;
  @Prop() icon: TIcon;
  @Prop() badge?: boolean;
  @Prop() selected?: boolean;
  @Prop() href?: string;
  @Prop() target?: '_blank' | '_self' | '_parent' | '_top';
  @Prop() rel?: string;

  render() {
    const classes = {
      'meta-nav-link': true,
      'meta-nav-link--selected': this.selected,
      'meta-nav-link--badge': this.badge,
    };

    return (
      <a
        class={classes}
        href={this.href}
        target={this.target}
        rel={this.rel}
        aria-label={this.label}>
        <dc-ui-icon name={this.icon} />
        <span>{this.label}</span>
      </a>
    );
  }
}
